<template lang="pug">
    v-alert.mt-6.text-left(:value ="isShowed" outlined dense text :type="$store.state.global.alert.type" dismissible transition="scroll-y-transition") {{$store.state.global.alert.message}}
</template>
<script>
export default {
  props: {
    permanent: {
      type: Boolean,
      default: false
    },
    interval: {
      type: Number,
      default: 5000
    }
  },
  methods: {
    removeAlert() {
      this.$store.dispatch("global/closeAlert")
    }
  },
  computed: {
    isShowed() {
      return this.$store.state.global.alert.show
    }
  },
  watch: {
    isShowed(val) {
      if (val && (this.permanent == false || this.$store.state.global.alert.type == "success")) {
        setTimeout(this.removeAlert, this.interval)
      }
    }
  }
}
</script>
